import api from './../api';

export const categoryServices = {
    getCategories: async (withResponse = false, defaultResponse = null) => {
        let response = await api
            .get('/categories')
            .then((res) => res)
            .catch((err) => err.response);

        return withResponse
            ? response
            : response.status === 200
            ? response.data
            : defaultResponse;
    },

    getCategory: async (
        category_id,
        withResponse = false,
        defaultResponse = null,
    ) => {
        let response = await api
            .get(`/category/${category_id}`)
            .then((res) => res)
            .catch((err) => err.response);

        return withResponse
            ? response
            : response.status === 200
            ? response.data
            : defaultResponse;
    },
};
